<template>
  <Card>
    <h1 slot="Title">Commitment Item (2617)</h1>
    <div slot="MainContent">
      <p>
        Object classes are categories in a classification system that presents obligations by the items or services purchased by the Federal Government. These are the major object classes: 
      </p>
      <ul class="Wrapper">
        <li>
          <b>10</b>: Personnel compensation and benefits
        </li>
        <li>
          <b>20</b>: Contractual services and supplies
        </li>
        <li>
          <b>26</b>: Supplies and materials
        </li>
        <li>
          <b>30</b>: Acquisition of assets
        </li>
        <li>
          <b>40</b>: Grants and fixed charges
        </li>
        <li>
          <b>90</b>: Other
        </li>
        <li>
          <ul>
            <li>
              <b>Position 5 - 6</b>:
            </li>
            <li>
              OMB 2 Character Object Class
            </li>
            <li>
              26: Supplies and Material Purchases 
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li>
              <b>Position 7</b>:
            </li>
            <li>
              Depot Level Reparable (DLR)
            </li>
            <li>
              K: Army Managed DBOF Items (DLR)<br>
              1: Army Managed DWCF Items (Non‑DLR)
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li>
              <b>Position 8</b>:
            </li>
            <li>
              Material Category
            </li>
            <li>
              7: Combat Vehicle Repair Parts 
            </li>
          </ul>
        </li>
      </ul>
      <p class="mt-8">
         202011D20 A76VV 131096QLOG 6100.<b><u>2617</u></b> WBS, Internal Order or Cost Center 1000000067 021001
      </p>
    </div>
    <p><strong>Commitment Item </strong><strong>(</strong><strong>2617</strong><strong>)</strong></p>
    <p><u><strong>Instructor and Students </strong></u><strong>go to http://</strong><strong>www.asafm.army.mil</strong> <strong>&gt; </strong><strong>Army Management Structure (Federated ERPs) Guide chapter 7</strong></p>
    <p>Position 5 &ndash; 6:&nbsp; &nbsp; OMB 2 Character Object Class&nbsp; 26 - Supplies and Material Purchases</p>
    <p>Position 7:&nbsp;&nbsp; &nbsp; Depot Level Reparable (DLR)&nbsp; 1 -&nbsp;&nbsp; Army Managed DBOF Items (DLR)</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; F&nbsp; -&nbsp; Army Managed DWCF Items (Non‑DLR)</p>
    <p>Position 8:&nbsp;&nbsp; &nbsp; Material Category&nbsp; &nbsp; 7&nbsp;&nbsp; (Combat Vehicle Repair Parts)</p>
    <p>2B-EOR- Pay (deals with personnel) 1000 series</p>
    <p>2B-EOR-NonPay (deals with contracts) 2000 series and above</p>
    <p>Every obligation recorded by the Department of Defense must be coded with an Commitment Item. These obligations by Commitment Item must be accumulated and reported to the Treasury on a quarterly basis. We divide the&nbsp; major classes into smaller classes and present them in the Budget Appendix in object class schedules.</p>
    <p>&nbsp;</p>
    <p><strong>Army Management Structure (Federated ERPs) Guide &gt;go to chapter 7 for definition, then click on</strong><strong> Data Reference files (excel spread sheet) to show crosswalk.</strong></p>
  </Card>
</template>
<style scoped>
ul > li {
  margin-bottom: 0;
}
ul > li > ul {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1250px;
  padding-left: 0;
}

ul > li > ul > li {
  width: 40%;
  list-style-type: none;
}

ul > li > ul > li:nth-child(1) {
  width: 20%;
  list-style-type: none;
}

.Wrapper > li:nth-child(odd) {
  background-color: rgba(255, 255, 255, .2);
}

</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'CommitmentItem2617',
  
  data() {
    return {
      Image: require('@/assets/The Basic 6-Digit USSGL Accounts Classification_150ppi.png')
    }
  }
  
}
</script>